import { useInjection } from "@linkfluence/core/di";
import {
  UserRepo,
  UserRepositoryUID,
} from "@linkfluence/core/user/repositories/UserRepo";
import { User } from "@linkfluence/models/user";
import { useQuery } from "@tanstack/react-query";

export function useUserPictures(user: User) {
  const repository = useInjection<UserRepo>(UserRepositoryUID);
  const {
    data: pictures,
    status,
    isFetching,
  } = useQuery(["/user/avatars", { user: user.id }], () =>
    repository.getUserPictures(user.id)
  );
  return {
    pictures,
    loading: status === "loading" || isFetching,
  };
}
